import { render, staticRenderFns } from "./InAreaCheck.vue?vue&type=template&id=c98a32d2"
import script from "./InAreaCheck.vue?vue&type=script&lang=js"
export * from "./InAreaCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports